export default __webpack_public_path__ + "static/frame-pay-faster@2x-8e24239ef7efec53a97d914263e59307.jpg";